import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from "@angular/router";

@Component({
  selector: 'app-statement-of-accounts',
  templateUrl: './statement-of-accounts.component.html',
})
export class StatementOfAccountsComponent implements OnInit {
	soaform:FormGroup;
	constructor(
		private formBuilder: FormBuilder,
		private router: Router,
	) {}

	ngOnInit() {
		this.soaform = this.formBuilder.group({
			policyNumber:[''],
			insuredName:[''],
			selectFromDate:[''],
			selectToDate:[''],
			soatype:['']
		});
	}
	get f() { return this.soaform.controls; }
	submit(){
		let value = this.soaform.value.soatype;
		if(value == 'simple')
			this.router.navigate(['/simple-statement-of-accounts'])
		else if(value=="detailed")
			this.router.navigate(['/detailed-statement-of-accounts'])
	}
}
